import script from "./sw-item-editor-picture.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-picture.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-picture.vue?vue&type=style&index=0&id=fb2f82be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb2f82be"]])

export default __exports__